// extracted by mini-css-extract-plugin
export var contentWrapper = "IconWrapper-module--content-wrapper--rXhah";
export var iconWrapper = "IconWrapper-module--icon-wrapper--b1Mbg";
export var image1 = "IconWrapper-module--image1--ArM9l";
export var mainWrapper = "IconWrapper-module--main-wrapper--oNeqx";
export var mainWrapperProduct = "IconWrapper-module--main-wrapper-product--fCLE2";
export var subtitle = "IconWrapper-module--subtitle--zR-oM";